let offers_slider = new Swiper('.offers_slider', {
    autoHeight: true,
    loop: true,
    autoplay: {
        delay: 7000,
    },
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    pagination: {
        el: '.offers_nav',
        type: 'bullets',
        clickable: true,
        dynamicBullets: true
    }
});

let guestRooms_mobileSlider = new Swiper('.guestRooms_mobileSlider', {
    loop: true,
    autoHeight: true,
    autoplay: {
        delay: 5000
    },
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    pagination: {
        el: '.guestRooms_nav',
        type: 'bullets',
        clickable: true,
        dynamicBullets: true
    }
});
let guestRooms_swiper = new Swiper('.guestRooms_swiper', {
    loop: true,
    autoplay: {
        delay: 5000
    },
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    navigation: {
        prevEl: '.guestRooms_swiper-prev',
        nextEl: '.guestRooms_swiper-next'
    }
});

let overview_gallery_mobile = new Swiper('.overview_gallery-mobile', {
    loop: true,
    autoplay: {
        delay: 5000
    },
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    pagination: {
        el: '.overview_gallery-pagination',
        type: 'bullets',
        clickable: true,
        dynamicBullets: true
    }
});

function loadSwitchLocations(){
    let buttons = document.querySelectorAll(`.locations_swtich a`);
    buttons.forEach(button => {
        if( !button.dataset.select )
            return;
        
        button.addEventListener('click', e => {
            e.preventDefault();
            let dataAttr = button.dataset.select;

            // Remove 'active' from all buttons
            buttons.forEach(btn => btn.classList.remove('active'));
            // Add 'active' to the clicked button
            button.classList.add('active');

            let allMetrics = document.querySelectorAll(`.locations_metrics span`);
            allMetrics.forEach( metric => {
                if( metric.dataset.option == dataAttr )
                    metric.classList.remove('hidden');
                else
                    metric.classList.add('hidden');
            });
        });
    });

    if( buttons[0] ){
        buttons[0].click();
    }
}

function handleHeaderHeightLogo(){
    const headerLogo = document.querySelector('.js-header_logo');

    if( !headerLogo.querySelector('img') )
        return headerLogo.style.minHeight = '40px';

    let image = headerLogo.querySelector('img');
    if( image.getBoundingClientRect().height == 0 ){
        let lookForImg = setInterval(() => {
            console.log('🦆 Looking for image height...', image.getBoundingClientRect().height);
            if( image.getBoundingClientRect().height > 0 ){
                headerLogo.style.minHeight = `${image.getBoundingClientRect().height}px`;
                clearInterval(lookForImg);
            }
        }, 100);
    }else{
        headerLogo.style.minHeight = `${image.getBoundingClientRect().height}px`;
    }

    if(document.querySelector(`.main_nav`))
        handleFixedPosNav();
}

function handleHeaderLangs() {
    const selected = document.querySelector('.js-header_langs-selected');
    const selector = document.querySelector('.js-header_langs-selector');

    if (!selected || !selector) return;

    selected.addEventListener('click', () => {
        selector.classList.toggle('active');
    });
}

function handleFixedPosNav(){
    const mainNav = document.querySelector('.js-main_nav');
    const mainNavHolder = mainNav.parentElement;
    const headerHeight = document.querySelector('#header').getBoundingClientRect().height;
    const mainNavOffsetTop = mainNav.getBoundingClientRect().top;
    const mainNavHeight = mainNav.getBoundingClientRect().height;

    mainNavHolder.style.minHeight = `${mainNavHeight}px`;
    mainNav.setAttribute('data-height_header', `${Math.floor(headerHeight)}`);

    window.addEventListener('scroll', () => {
        if( window.scrollY >= mainNavOffsetTop + mainNavHeight ){
            mainNav.classList.add('fixed');
        }else{
            mainNav.classList.remove('fixed');
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    if(document.getElementById(`locations`))
        loadSwitchLocations();

    if(document.querySelector(`.main_nav`))
        handleFixedPosNav();

    if(document.querySelector(`.js-header_langs-selected`))
        handleHeaderLangs();
    
    if( document.querySelector(`.js-header_logo`) )
        handleHeaderHeightLogo();
});